class PartbotCollectionSearch extends HTMLElement {
  constructor() {
    super();

    this.skus = [];
    this.vehicle_ids = [];
    this.activeVehicleIds = [];
    this.selectedYear = null;
    this.brands = this.getAttribute("data-vendors")
      ? this.getAttribute("data-vendors").split(",")
      : [];
    this.product_types = this.getAttribute("data-product-types")
      ? this.getAttribute("data-product-types")
          .split(",")
          .filter((str) => str.trim() !== "")
      : [];

    this.facets = this.getAttribute("data-facets")
      ? this.getAttribute("data-facets")
          .split(",")
          .filter((str) => str.trim() !== "")
      : [];

    this.filters = this.getAttribute("data-filters");

    this.showVehicleSearch =
      this.getAttribute("data-show-vehicle-search") === "true";

    this.partbot_vehicle = localStorage.getItem("partbot_selected_vehicle");
    this.partbot_plate_details = localStorage.getItem("partbot_plate_details");
    this.activeVehicleQuery = window.location.search.includes("make=");
    this.platesearch_ids = [];

    console.log("this.showVehicleSearch", this.showVehicleSearch);

    if (
      this.showVehicleSearch &&
      this.partbot_vehicle &&
      this.partbot_plate_details &&
      !this.activeVehicleQuery
    ) {
      this.partbot_vehicle = JSON.parse(this.partbot_vehicle);
      this.platesearch_ids = this.partbot_vehicle.vehicle_ids;

      const vehicleDescription = document.querySelector(
        ".js-vehicle-description"
      );

      vehicleDescription.textContent = this.partbot_vehicle.description;

      const clearButton = document.querySelector(".js-button-clear-vehicle");
      clearButton.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        localStorage.removeItem("partbot_selected_vehicle");
        localStorage.removeItem("partbot_plate_details");
        location.reload();
      });

      const vehicleNotice = document.querySelector(
        ".js-selected-vehicle-notice"
      );

      vehicleNotice.classList.remove("hidden");
      vehicleNotice.classList.add("flex");

      document.querySelector("vehicle-search").classList.add("hidden");
    }

    this.facetFiltersContainer = this.querySelector("#facet-filters");

    // configure Algolia
    this.algoliaAppId = this.getAttribute("data-algolia-app-id");
    this.algoliaApiKey = this.getAttribute("data-algolia-api-key");
    this.algoliaIndexName = this.getAttribute("data-algolia-index");

    this.hitsContainer = this.querySelector("#partbot-product-grid");

    // hide the hitsContainer if there is a make parameter in the query string
    if (window.location.search.includes("make=")) {
      this.hitsContainer.style.display = "none";
    }

    // listen for vehicle search changes
    this.onVehicleSearchChange = this.applyVehicleSearchSelection.bind(this);
    this.filterAlgoliaHits = this.processHits.bind(this);

    const searchClient = algoliasearch(this.algoliaAppId, this.algoliaApiKey);

    this.search = instantsearch({
      indexName: this.algoliaIndexName,
      searchClient,
      routing: false,
      searchFunction: (helper) => {
        if (this.vehicle_ids) {
          this.vehicle_ids.map((id) => {
            helper.addDisjunctiveFacetRefinement("vehicle_ids", id);
          });
          this.vehicle_ids = [];
        }
        helper.search();
      },
      onStateChange: ({ uiState, setUiState }) => {
        // show the container if this.activeVehicleIds is not empty and make is in the query string
        if (
          this.activeVehicleIds.length > 0 &&
          window.location.search.includes("make=")
        ) {
          this.hitsContainer.style.display = "block";
        }

        setUiState(uiState);
      },
    });

    let vehicleIdFilter = "";
    if (this.showVehicleSearch && this.platesearch_ids.length > 0) {
      let vehicle_id_filters = this.platesearch_ids
        .map((vehicle_id) => `vehicle_ids:${vehicle_id}`)
        .join(" OR ");
      vehicleIdFilter = `${vehicle_id_filters}`;
    }

    let filters = "";
    if (this.brands.length > 0) {
      let brand_filters = this.brands
        .map((brand) => `vendor:'${brand.replace(/'/g, "\\'")}'`)
        .join(" OR ");
      filters = `(${brand_filters})`;
    }

    if (this.product_types.length > 0) {
      let product_type_filters = this.product_types
        .map(
          (product_type) =>
            `product_type:'${product_type.replace(/'/g, "\\'")}'`
        )
        .join(" OR ");
      filters = filters
        ? `${filters} AND (${product_type_filters})`
        : `(${product_type_filters})`;
    }

    if (this.filters) {
      filters = filters
        ? `${filters} AND (${this.filters})`
        : `(${this.filters})`;
    }

    if (vehicleIdFilter.length > 0) {
      filters = filters
        ? `${filters} AND (${vehicleIdFilter})`
        : `(${vehicleIdFilter})`;
    }

    // add published:true to filters
    filters = filters ? `${filters} AND published:true` : `published:true`;

    this.search.addWidgets([
      instantsearch.widgets.configure({
        hitsPerPage: 15,
        distinct: true,
        filters: filters,
        facetingAfterDistinct: true,
        facets: [
          "vendor",
          "product_type",
          "vehicle_years.year_from",
          "vehicle_years.year_to",
          "attributes",
          "vehicle_makes",
        ].concat(this.facets),
        disjunctiveFacets: [
          "vehicle_years.year_from",
          "vehicle_years.year_to",
          "vehicle_ids",
          "attributes",
          "vehicle_makes",
        ],
      }),
    ]);

    // Add Facet Filters
    if (this.facets && this.facets.length) {
      this.facets.forEach((facet) => {
        let node = document.createElement("div");
        let facet_id = facet.replace(/[\s_]+/g, "-");
        node.innerHTML = `<div class="partbot-filter-title">${facet
          .replace(/_/g, " ")
          .replace(
            "vendor",
            "brand"
          )}</div><div id='partbot-filter-${facet_id}'></div>`;

        let attr_title = ["Brand", "Vendor", "Product Type"].find((v) =>
          facet.includes(v)
        )
          ? facet.replace("Brand", "Vendor").toLowerCase().replace(/ /g, "_")
          : `attributes.${facet}`;

        this.facetFiltersContainer.appendChild(node);
        this.search.addWidgets([
          instantsearch.widgets.refinementList({
            container: `#partbot-filter-${facet_id}`,
            attribute: attr_title,
            operator: "and",
            limit: 100,
            sortBy: ["title:desc"],
            templates: {
              item: document.querySelector("#partbot-filter-template")
                .innerHTML,
            },
            cssClasses: {
              root: "partbot-filter-values",
              list: "partbot-filter-list",
            },
          }),
        ]);
      });
    }

    this.search.addWidget(
      instantsearch.widgets.pagination({
        container: "#partbot-pagination",
        autoHideContainer: true,
        padding: 1,
        scrollTo: "#partbot-product-grid",
        templates: {
          first: "<<",
          previous: "<",
          next: ">",
          last: ">>",
        },
        cssClasses: {
          list: "partbot-pagination-list",
          selectedItem: "active",
          link: "partbot-pagination-button",
          disabledItem: "disabled hidden",
          firstPageItem: "partbot-pagination-control",
          lastPageItem: "partbot-pagination-control",
          nextPageItem: "partbot-pagination-control",
          previousPageItem: "partbot-pagination-control",
        },
      })
    );

    // Add Hits Widget
    const filterM = this.filterAlgoliaHits;
    let _this = this;
    this.search.addWidget(
      instantsearch.widgets.hits({
        container: "#partbot-product-grid",
        cssClasses: {
          list: `partbot-product-grid-list ${
            this.facets && this.facets.length ? "has-filters" : ""
          }`,
        },
        templates: {
          item: document.querySelector("#partbot-product-card-template")
            .innerHTML,
          empty: document.querySelector("#partbot-empty-template").innerHTML,
        },
        transformItems(items) {
          _this.skus = [];
          return items.filter(filterM, this).filter((i) => i);
        },
      })
    );

    this.search.start();

    // Listen for vehicle search changes
    document.addEventListener(
      "vehicle-search-change",
      this.onVehicleSearchChange
    );
  }

  processHits(item) {
    if (this.selectedYear) {
      // collect all year_froms <= selectedYear and year_tos >= selectedYear
      var yf_vehicle_ids = [];
      var yt_vehicle_ids = [];
      var yf_permitted, yt_permitted;
      if (
        item.hasOwnProperty("vehicle_years") &&
        item.vehicle_years.hasOwnProperty("year_from") &&
        item.vehicle_years.hasOwnProperty("year_to")
      ) {
        // collect year_froms
        for (var year in item.vehicle_years.year_from) {
          if (year <= this.selectedYear) {
            yf_vehicle_ids.push(item.vehicle_years.year_from[year]);
          }
        }

        // collect year_tos
        for (var year in item.vehicle_years.year_to) {
          if (year >= this.selectedYear) {
            yt_vehicle_ids.push(item.vehicle_years.year_to[year]);
          }
        }

        yf_vehicle_ids = yf_vehicle_ids.flat();
        yt_vehicle_ids = yt_vehicle_ids.flat();

        yf_permitted = this.activeVehicleIds.filter((n) =>
          yf_vehicle_ids.includes(n)
        );

        yt_permitted = this.activeVehicleIds.filter((n) =>
          yt_vehicle_ids.includes(n)
        );

        // remove from results if not permitted
        if (yf_permitted.length === 0 || yt_permitted.length === 0) {
          return false;
        }
      }
    }

    // truncate item.title to 140 characters
    if (item.title.length > 140) {
      item.title = item.title.substring(0, 140) + "...";
    }

    // is multi_variant?
    item.multi_variant = item.variant_skus && item.variant_skus.length > 1;

    // check if the item has a compare_at_price_from value and if it is less than or equal to the price_from value set it to null
    if (
      item.compare_at_price_from &&
      item.compare_at_price_from <= item.price_from
    ) {
      item.compare_at_price_from = null;
    }

    // convert all attribute keys from "Towing Capacity" to "towing_capacity"
    if (item.attributes) {
      item.attributes = Object.keys(item.attributes).reduce((acc, key) => {
        acc[key.toLowerCase().replace(/ /g, "_")] = item.attributes[key];
        return acc;
      }, {});
    }

    return item;
  }

  applyVehicleSearchSelection(e) {
    if (this.platesearch_ids && this.platesearch_ids.length) {
      return false;
    }

    if (!this.search.helper) {
      this.vehicle_ids = e.detail.vehicle_ids;
      return false;
    }
    this.search.helper.clearRefinements("vehicle_ids");
    this.search.helper.clearRefinements("vehicle_makes");

    if (e.detail.vehicle.make) {
      this.search.helper.addFacetRefinement(
        "vehicle_makes",
        e.detail.vehicle.make.value
      );
    }

    if (e.detail.vehicle.year) {
      this.selectedYear = parseInt(e.detail.vehicle.year.value);
    } else {
      this.selectedYear = null;
    }

    this.activeVehicleIds = e.detail.vehicle_ids;

    if (this.activeVehicleIds) {
      this.activeVehicleIds.map((id) => {
        this.search.helper.addDisjunctiveFacetRefinement("vehicle_ids", id);
      });

      this.search.helper.search();
    }
  }
}

customElements.define("partbot-collection-search", PartbotCollectionSearch);
